<template>
  <div class="DetailsLeft">
    <div class="information">
      <p class="inforTitle flex_ai_center">租赁企业信息</p>
      <p class="inforTxt"><span class="colorGray">设备数量：</span><span>86台</span></p>
      <p class="inforTxt"><span class="colorGray">入驻时间：</span><span>2年</span></p>
      <div class="contList">
        <span class="colorGray">服务范围：</span>
        <ul class="service_area">
          <li class="floatLeft">
            <img src="" />
            <p class="flex_jc_center">挖掘机</p>
          </li>
          <li class="floatLeft">
            <img src="" />
            <p class="flex_jc_center">推土机</p>
          </li>
          <li class="floatLeft">
            <img src="" />
            <p class="flex_jc_center">叉车</p>
          </li>
          <li class="floatLeft">
            <img src="" />
            <p class="flex_jc_center">起重机</p>
          </li>
          <div class="clearB"></div>
        </ul>
      </div>
    </div>
    <div class="contact_way">
      <p class="inforTitle flex_ai_center">联系方式</p>
      <p class="inforTxt"><span class="colorGray">联系人：</span><span>播放速度加快</span></p>
      <p class="inforTxt"><span class="colorGray">联系电话：</span><span>134384554545</span></p>
      <p class="inforTxt"><span class="colorGray">联系地址：</span><span>你的萨克比你大刊部分的卡萨甲方那边卡萨丁不是速度快部分空间是否可不能靠技术</span></p>
      <div class="mapCont">
        <img src="" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DetailsLeft',
  components: {

  },
  data () {
    return {

    }
  },
  mounted () {},
  // 方法
  methods: {

  },
  watch: {

  },
  created () {}
}
</script>

<style  lang="scss" rel="stylesheet/scss" scoped>
.DetailsLeft {
    width: 30%;
    >div {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #E0E5EA;
        border-radius: 10px;
    }
    .information,.contact_way {
        margin-bottom: 30px;
        p.inforTxt {
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
            padding: 0 25px;
            box-sizing: border-box;
        }
        .contList {
            margin-bottom: 10px;
            padding: 0 25px;
            box-sizing: border-box;
            >span {
                display: block;
                font-size: 14px;
                margin-bottom: 10px;
            }
            .service_area {
                width: 100%;
                margin: 0;
                list-style-type: none;
                padding: 0;
                li {
                    width: 30%;
                    margin-bottom: 10px;
                    margin-right: 5%;
                    cursor: pointer;
                    img {
                        display: block;
                        width: 100%;
                        height: 65px;
                        margin-bottom: 10px;
                    }
                    p {
                        font-size: 14px;
                        color: #000000;
                    }
                }
                li:nth-of-type(3n) {
                    margin-right: 0;
                }
            }
        }
        .colorGray {
            color: #A4A4A4;
        }
        .mapCont {
            width: 100%;
            height: 300px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    p.inforTitle {
        margin-bottom: 15px;
        padding: 0 25px;
        height: 60px;
        box-sizing: border-box;
        font-size: 16px;
        box-shadow:0 1px 2px #F1F1F1
    }
    .floatLeft {
        float: left;
    }
    .clearB {
        clear: both;
    }
}
</style>
